import { styled } from '@mui/material';

const StyledReportAboutPageWrap = styled('div')(() => ({
	display: 'grid',

	gridTemplateColumns: '1fr',
	gap: '16px',
	gridAutoRows: '265px',
}));

export default StyledReportAboutPageWrap;
